module.exports = __webpack_public_path__ + "static/code-5ef61653cf8e910debb1d1013c3e519d.png";